import React, { useState } from "react";
// import {
//   DataGridPro,
//   GridToolbar,
//   GridToolbarExport,
// } from "@mui/x-data-grid-pro";
import {
  DataGridPremium,
  GridToolbar,
  // GridToolbarExport,
} from '@mui/x-data-grid-premium';
import { Tag } from "@instructure/ui-tag";
import { Flex } from "@instructure/ui-flex";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ContentCopy from "@mui/icons-material/ContentCopy";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { viVN } from "@mui/x-data-grid/locales";
import "./css/table.css";

export const TableComponent = ({
  headers,
  rows,
  perPage,
  selectedIds,
  setSelectedIds,
}) => {
  const [copiedRow, setCopiedRow] = useState(null);
  const [pageSize, setPageSize] = useState(5); // Initialize the page size
  const [passwordVisibility, setPasswordVisibility] = useState({}); // Store visibility per row

  // Toggle visibility of the password for a specific row
  const togglePasswordVisibility = (rowId) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId], // Toggle the visibility only for the specific row
    }));
  };

  // Copy password to clipboard and set state for the copied row
  const copyToClipboard = (password, rowId) => {
    navigator.clipboard.writeText(password);
    setCopiedRow(rowId); // Mark the row as copied
    setTimeout(() => setCopiedRow(null), 2000); // Clear the copied state after 2 seconds
  };

  // Format date in 'dd/mm/yyyy' format for 'NGÀY SINH' column
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("vi-VN"); // Formats as 'dd/mm/yyyy'
  };

  // Define columns with custom rendering for certain fields
  const columns = headers.map((header) => ({
    field: header.id,
    headerName: header.text,
    width: header.width ? parseInt(header.width) : 150,
    headerClassName: "custom-header",
    sortable: true,
    filterable: true,
    renderCell: (params) => {
      const rowId = params.row.MA_HOC_SINH;

      if (header.id === "username") {
        const value = params.value;
        return value ? <span>{value}</span> : <span>Chưa đặt</span>;
      }

      // Handle 'default_password' column
      if (header.id === "default_password") {
        const isVisible = passwordVisibility[rowId]; // Get visibility state for the current row
        const passwordValue = params.value;

        if (!passwordValue) {
          return <span>Chưa đặt</span>; // Show 'Chưa đặt' if password is not set
        }

        return (
          <Flex direction="row" alignItems="center" className="cell-content">
            <span>{isVisible ? passwordValue : "*****"}</span>{" "}
            {/* Show password or mask it */}
            <button
              onClick={() => togglePasswordVisibility(rowId)} // Toggle visibility for this row
              className="icon-button password-icons"
              title={isVisible ? "Hide Password" : "Show Password"}
            >
              {isVisible ? <VisibilityOff /> : <Visibility />}
            </button>
          </Flex>
        );
      }

      // Handle 'MA_LOP' column with custom tag
      if (header.id === "MA_LOP") {
        return <Tag text={params.value} className="custom-tag" />;
      }

      // Format date for 'NGÀY SINH' column
      if (header.id === "NGAY_SINH") {
        return formatDate(params.value);
      }

      // Default rendering for other columns
      return params.value;
    },
  }));

  return (
    <div className="data-grid-container">
      {/* <DataGridPro
        rows={rows}
        columns={columns}
        pageSize={pageSize}  // Set the current page size
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}  // Handle page size change
        rowsPerPageOptions={[5, 10, 25, 100]}  // Options for rows per page
        components={{ Toolbar: GridToolbar }}
        getRowId={(row) => row.MA_HOC_SINH}  // Use 'MA_HOC_SINH' as the row ID
        checkboxSelection
        localeText={viVN.components.MuiDataGrid.defaultProps.localeText}
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newRowSelectionModel) => setSelectedIds(newRowSelectionModel)}
        rowSelectionModel={selectedIds}
        pagination  // Enables pagination
        paginationMode="client"  // Optional: Use client-side pagination
        slots={{ toolbar: GridToolbar }}
      /> */}
      <DataGridPremium
        rows={rows}
        columns={columns}
        pageSize={pageSize} // Set the current page size
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} // Handle page size change
        rowsPerPageOptions={[5, 10, 25, 100]} // Options for rows per page
        components={{ Toolbar: GridToolbar }}
        getRowId={(row) => row.MA_HOC_SINH} // Use 'MA_HOC_SINH' as the row ID
        checkboxSelection
        localeText={viVN.components.MuiDataGrid.defaultProps.localeText}
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newRowSelectionModel) =>
          setSelectedIds(newRowSelectionModel)
        }
        rowSelectionModel={selectedIds}
        pagination // Enables pagination
        paginationMode="client" // Optional: Use client-side pagination
        slots={{ toolbar: GridToolbar }}
        // slotProps={{ toolbar: { excelOptions } }}
      />
    </div>
  );
};
